export const LOGIN_ENDPOINT = '/auth/login'
export const GRANT_TYPE = 'client_credentials'
export const CLIENT_ID = '9d767aa9-3dd4-42f0-84f5-547b103c47a5'
export const CLIENT_SECRET = 'uP4SxyGyKugoBfEVNBconCJqCHt9UfsGf2B7qEwL'
